export const assessmaxBaseurl = 'https://civilvertexai.com';
//export const assessmaxBaseurl = `http://${window.location.hostname}:8004`;
export const clientsList = '/api/clients/list';
export const clientsAdd = '/api/clients/';
export const clientDetail = '/api/clients';
export const clientDelete = '/api/clients/';

export const sitesList = '/api/sites/list';
export const sitesAdd = '/api/sites/';
export const siteDetail = '/api/sites';
export const siteDelete = '/api/sites/';

export const projectAdd = '/api/projects/';
export const projectsList = '/api/projects/list';
export const projectDetail = '/api/projects';
export const projectDelete = '/api/projects/';

export const projectResumeDetail = '/api/project-status';

export const projectEstimation = '/api/project-estimation/';

export const foundationEstimationResult = '/api/estimation/run-foundation';
export const plinthEstimationResult = '/api/estimation/run-plinth-beam';
export const gfBeamEstimationResult = '/api/estimation/run-gfb';
export const gfSlabEstimationResult = '/api/estimation/run-gfslab';
export const wfdEstimationResult = '/api/estimation/run-wfd';
export const lintelBeamEstimationResult = '/api/estimation/run-lb';
export const gfColumnEstimationResult = '/api/estimation/run-column';
export const runStaircaseEstimationResult = '/api/estimation/run-staircase';
export const estimationRunRatesSummaryJson = '/api/estimation/run-rates-summary-json';
export const estimationRunCostSummaryJson = '/api/estimation/run-cost-summary-json';
export const saveActualCost = '/api/estimation/run-cost-summary-json';  // PUT method
export const estimationRunRatesSummary = '/api/estimation/run-rates-summary';
export const estimationRunCostSummary = '/api/estimation/run-cost-summary';
export const estimationRunMaterialSummary = '/api/estimation/run-material-summary';
export const estimationRunMaterialSummaryJson = '/api/estimation/run-material-summary-json';
export const saveMaterialProcurement = '/api/estimation/run-material-summary-json';  // PUT method
export const estimationRunLabourSummary = '/api/estimation/run-labour-summary';
export const estimationRunLabourSummaryJson = '/api/estimation/run-labour-summary-json';
export const saveLabourAllocation = '/api/estimation/run-labour-summary-json';  // PUT method
export const runCpm = '/api/estimation/run-cpm';
export const getCpmResult = (projectId) => `/api/estimation/cpm-result/${projectId}`;
export const updateActivityActualStart = '/api/estimation/activity-actual-start';
export const updateActivityActualFinish = '/api/estimation/activity-actual-finish';
export const updateProjectWorkStart = '/api/estimation/project-work-start';
export const materialRatesGet = '/api/material-rates/default';
export const materialRatesSave = '/api/material-rates';
export const labourRatesGet = '/api/labour-rates/default';
export const labourRatesSave = '/api/labour-rates';
export const projectRatesGet = '/api/rates';
export const projectRatesSave = '/api/rates';
export const projectRatesReset = '/api/rates';

export const loginToken = '/api/auth/token';
export const refresh = '/api/auth/refresh-token';
export const loginUser = '/api/auth/login';
export const registerUser = '/api/auth/register';
export const resetPassword = '/api/auth/reset-password';
export const logoutUser = '/api/auth/logout';

export const overviewData = '/api/dashboard/metrics';
export const clientMetrics = '/api/dashboard/client-metrics';

export const userList = '/api/users/list';
export const userDetail = '/api/users';
export const userAdd = '/api/user/add';
export const userUpdate = '/api/users/update-profile';
export const passwordSet = '/api/user/password/set';
export const assessmentList = '/api/assessment/list';
export const assessmentAdd = '/api/assessment/add';
export const patientList = '/api/patient/list';
export const patientDetail = '/api/patient/detail';
export const runAssessmentList = '/api/run/assessment/list';
export const runAssessmentClientList = '/api/run/assessment/client/list';
export const runAssessmentClientStatusCount = '/api/run/assessment/client/status/count';

// Plans API
export const plansList = '/api/plans';
export const plansListPost = '/api/plans/list';
export const plansAdd = '/api/plans';
export const planDetail = '/api/plans';
export const planUpdate = '/api/plans';
export const planDelete = '/api/plans';
export const plansCurrent = '/api/plans/current';
export const plansAvailable = '/api/plans/available';
export const plansAssign = '/api/plans/assign';
export const plansChange = '/api/plans/change';

// Task Progress & Assessment endpoints (matching backend)
export const projectTasks = (projectId) => `/api/projects/${projectId}/tasks`;
export const projectCpm = (projectId) => `/api/projects/${projectId}/cpm`;
export const projectProgressSummary = (projectId) => `/api/projects/${projectId}/progress-summary`;
export const projectPendingAssessments = (projectId) => `/api/projects/${projectId}/pending-task-assessments`;
export const taskAssessments = (projectId, taskId) => `/api/projects/${projectId}/tasks/${taskId}/assessments`;
export const taskAssessmentPhoto = (projectId, taskId, assessmentId) => `/api/projects/${projectId}/tasks/${taskId}/assessments/${assessmentId}/photo`;
export const taskAssessmentApprove = (projectId, taskId, assessmentId, approved) => 
  `/api/projects/${projectId}/tasks/${taskId}/assessments/${assessmentId}/approve?approved=${approved}`;

// Milestone endpoints
export const projectMilestones = (projectId) => `/api/projects/${projectId}/milestones`;
export const projectMilestoneDetail = (projectId, milestoneId) => `/api/projects/${projectId}/milestones/${milestoneId}`;
export const milestoneTasks = (projectId, milestoneId) => `/api/projects/${projectId}/milestones/${milestoneId}/tasks`;
export const milestoneTaskUnlink = (projectId, milestoneId, taskId) => `/api/projects/${projectId}/milestones/${milestoneId}/tasks/${taskId}`;